import React from 'react'
import './_technologies.scss'

const Technologies = () => {
  return (
    <div>
      {' '}
      <main className='technologies' id='technologies'>
        <div className='technologies-title'>
          <p className='technologies-title-name'>Technologies...</p>
        </div>
        <div className='technologies-skills'>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain-wordmark.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain-wordmark.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-plain.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-plain.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original-wordmark.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg'
            />
          </div>
          <div className='technologies-skills-img'>
            <img
              alt=''
              src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original-wordmark.svg'
            />
          </div>
        </div>
      </main>
    </div>
  )
}

export default Technologies
